import { useState } from 'react';
import { PAGINATION_PER_PAGE } from '../utils/constants';

export const useSimplePagination = (current = 1, total = 0) => {
  const [currentPage, setCurrentPage] = useState(current);
  const [totalPages, setter] = useState(total);

  const onPageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const setTotalPages = (
    total: number,
    limit: number = PAGINATION_PER_PAGE
  ) => {
    setter(Math.ceil((total ?? 0) / limit));
  };

  return {
    currentPage,
    totalPages,
    onPageChange,
    setTotalPages,
  };
};
